import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import { ColorFunction } from '@styles/colors/types';
import TouchableElement from '@components/common/touchableElement';
import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import type { ScaleFunction } from '@components/operatorPanel/interfaces';

interface ModalHeaderProps {
  cancelText?: string;
  submitText?: string;
  onCancel: () => void;
  onSubmit: () => void;
  submitDisabled?: boolean;
  title?: string;
  C: ColorFunction;
  submitTestID?: string;
  cancelTestID?: string;
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

const ModalHeader: FC<ModalHeaderProps> = ({
  C,
  onCancel,
  onSubmit,
  submitDisabled = false,
  cancelText = 'Cancel',
  submitText = 'Done',
  title,
  submitTestID,
  cancelTestID,
  scale = initialScale,
  font = initialFont,
}) => {
  const buttonTextStyles = [font.Body, { paddingVertical: scale(7), paddingHorizontal: scale(12), color: C('Link/Light/Primary') }];

  return (
    <View style={{ alignItems: 'center' }}>
      <TouchableElement testID={cancelTestID} onPress={onCancel}>
        {({ boxStyle }) => (
          <View style={[boxStyle, { position: 'absolute', left: scale(12), top: scale(11) }]}>
            <Text style={buttonTextStyles}>{i18n.t(cancelText)}</Text>
          </View>
        )}
      </TouchableElement>

      {title && <Text style={[font.Headline, { color: C('Label/Light/Primary'), paddingTop: scale(18) }]}>{i18n.t(title)}</Text>}

      <TouchableElement testID={submitTestID} onPress={onSubmit} disabled={submitDisabled}>
        {({ boxStyle }) => (
          <View style={[boxStyle, { position: 'absolute', right: scale(12), top: scale(11), opacity: submitDisabled ? 0.4 : 1 }]}>
            <Text style={buttonTextStyles}>{i18n.t(submitText)}</Text>
          </View>
        )}
      </TouchableElement>
    </View>
  );
};

export default ModalHeader;
